
<template>
  <base-modal :title="title" :width="width" :visible="visible" @cancel="open(false)">
    <div slot="modalBody">
      <a-form :form="form">
        <a-row>
          <a-col :span="colSpan">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="编号"
              hasFeedback
            >
              <div class="text">{{ model.id||'暂无' }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="试卷名称"
              hasFeedback
            >
              <div class="text">{{ model.name||'暂无' }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="试卷答案"
              hasFeedback
            >
              <div class="text">{{ model.nameWithAnswer||'暂无' }}</div>
            </a-form-item>
          </a-col>
          <a-col :span="colSpan">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="生成时间"
              hasFeedback
            >
              <div class="text">{{ model.createTime||'暂无' }}</div>
            </a-form-item>
          </a-col>

          <a-col :span="24">
            <a-form-item :wrapper-col="{ span: 12, offset: 5 }" v-if="isEdit">
              <a-button style="margin-right:10px;" @click="cancel">
                关闭
              </a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </base-modal>
</template>

<script>
import baseModal from '@/CrComponents/Modal/Modal.vue'
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  name: 'EditPaper',
  mounted () {

  },
  computed: {
    isEdit () {
      return this.type !== this.$sysInfo.MODAL_VIEW
    },
    ...mapState({

    })
  },
  components: {
    baseModal
  },
  data () {
    return {
      title: '操作',
      width: 1000,
      type: 'add', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      infoLoading: false, // 编辑窗口，获取详情loading
      form: this.$form.createForm(this, { name: 'paper' }),
      visible: false,
      defaultModel: {},
      model: {
        id: '',
        name: '',
        nameWithAnswer: '',
        createTime: ''
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      labelCol2: {
        xs: { span: 24 },
        sm: { span: 3 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 21 }
      },
      colSpan: 12

    }
  },
  methods: {
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.visible = flag
      const data = this.model
      if ((this.type === this.$sysInfo.MODAL_MODIFY) || (this.type === this.$sysInfo.MODAL_VIEW)) {
        if (flag) {
          this.model.id = data.id
          this.model.name = data.name
          this.model.nameWithAnswer = data.nameWithAnswer
          this.model.createTime = moment(data.createTime, 'YYYY-MM-DD').utc(8)

          // this.getModelInfo(this.model) 通过接口获取详情
        }
      }
    },
    // 清空表单
    formClear () {
      this.model.id = ''
      this.model.name = ''
      this.model.nameWithAnswer = ''
      this.model.createTime = null
    },
    cancel () {
      this.formClear()
      this.open(false)
    }
    // 获取select列表

  }
}
</script>

<style scoped lang="less">
  .ant-form-item{
    .text,.textArea{
      border: 1px solid #e8e8e8;
      border-radius: 4px;
      padding: 0 10px;
    }
  }
</style>
